<template>
  <div class="container">
    <div
      class="author-item flx-col"
      v-for="(item, index) in followList"
      :key="index"
    >
      <div class="flx">
        <div
          class="avatar"
          :style="{ backgroundImage: 'url(' + item.headPic + ')' }"
        ></div>
        <div class="author-info flx-col ml-30">
          <div class="author-info-row1">
            <span class="s8 t1 fw-b fl-l">{{ item.nickName }}</span>
            <span class="btn-follow s5 t3 fl-r">已关注</span>
          </div>
          <div>
            <span class="s4 t3 mr-10">{{ item.typeName }}</span>
            <span class="s4 t3">|</span>
            <span class="s4 t3 ml-10">{{ item.authorCompany }}</span>
            <span class="fans s2 t3 fl-r mr-30"
              >粉丝 {{ item.followerNum }}</span
            >
          </div>
        </div>
      </div>
      <div class="split-line mt-30"></div>
    </div>
  </div>
</template>
<script>
import { getAuthorList } from '@/api/author'
export default {
  name: 'Follow',
  data() {
    return {
      headPic:
        'https://emapp-static.oss-cn-shanghai.aliyuncs.com/youkantou/20200918/98af54996272393d01992f2971b56f6d.png',
      followList: []
    }
  },
  created() {
    this.loadAuthorList()
  },
  methods: {
    async loadAuthorList() {
      var parm = { type: 1, pageSize: 100 }
      const res = await getAuthorList(parm)
      if (res && res.result.code === 0) {
        this.followList = res.detail.list
        console.log(this.followList)
      } else {
        // this.$router.push({ path: '/login' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
}
.author-item {
  margin: 30px;
}
.avatar {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
}
.author-info {
  flex: auto;
}
.author-info-row1 {
  flex: auto;
}
.btn-follow {
  display: inline-flex;
  width: 120px;
  height: 52px;
  border: 1px solid #858585;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
  float: right;
  cursor: pointer;
}
.fans {
  margin-top: 12px;
}

.flx {
  display: flex;
}
.flx-col {
  display: flex;
  flex-direction: column;
}
.split-line {
  height: 1px;
  background-color: #ebebeb;
}
.split-line-20 {
  height: 20px;
  background-color: #f0f0f0;
}
.mr-10 {
  margin-right: 10px;
}
.mt-30 {
  margin-top: 30px;
}
.mt-40 {
  margin-top: 40px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-30 {
  margin-bottom: 30px;
}
.mb-40 {
  margin-bottom: 40px;
}
.ml-10 {
  margin-left: 10px;
}
.ml-14 {
  margin-left: 14px;
}
.ml-20 {
  margin-left: 20px;
}
.ml-30 {
  margin-left: 30px;
}
.mr-30 {
  margin-right: 30px;
}
.fw-b {
  font-weight: bold;
}
.fl-l {
  float: left;
}
.fl-r {
  float: right;
}
</style>
